<script setup lang="ts">
import SelectorField from '@/components/Selector/SelectorField.vue'
import type { SelectorObject } from '@/types/components/SelectorObject'
import EditableFieldWrapper from './EditableFieldWrapper.vue'

defineProps<{
    label?: string
    tooltip?: string
    value?: string
    valueLabel?: string
    boldLabel?: boolean
    isInEditMode?: boolean
    showableElement?: boolean
    required?: boolean
    options?: SelectorObject[]
    errorText?: string
}>()
defineEmits<{ (e: 'change', value?: any): void }>()
</script>

<template>
    <EditableFieldWrapper
        :label="label"
        :tooltip="tooltip"
        :value="valueLabel ?? value"
        :boldLabel="boldLabel"
        :required="required"
        :showableElement="showableElement"
        :isInEditMode="isInEditMode">
        <SelectorField
            :options="options"
            :placeholder="label"
            :required="required"
            @change="$emit('change', $event)"
            :modelValue="value"
            :errorText="errorText"
            v-bind="$attrs" />
    </EditableFieldWrapper>
</template>
